module.exports = __webpack_public_path__ + "img/teeth-32.54840a7f.png";